export default "__VITE_ASSET__CVD$Sk_C__"